import Link from "next/link";

import PropTypes from "prop-types";
import airbrake from "util/airbrake";
import Error404Page from "./404";
import styles from "../styles/404.module.scss";

function Error({ statusCode }) {
  if (statusCode === 404) return <Error404Page />;
  return (
    <div className={styles.container}>
      <div className={styles.errorHeader}>
        <span>Error {statusCode}</span>
        <h1 className="title">Something went wrong</h1>
      </div>
      <div className="inset">
        <p>
          {statusCode
            ? `An error has occurred on server`
            : "An error occurred on client"}
          <br />
          Try these links instead:
        </p>
        <ul>
          <li>
            <Link href="/">
              <a>Home</a>
            </Link>
          </li>
          <li>
            <Link href="/office-space/ny/new-york/">
              <a>Search for Office Space</a>
            </Link>
          </li>
          <li>
            <a href="/about">About SquareFoot</a>
          </li>
          <li>
            <a href="/contact-us">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  );
}

Error.getInitialProps = ({ res, err, req }) => {
  let statusCode = 404;
  if (res.statusCode) statusCode = res.statusCode;
  else if (err.statusCode) statusCode = err.statusCode;

  const { headers } = req;
  delete headers.cookie;
  airbrake.notify({
    error: err,
    context: { url: req.url, headers },
  });

  return { statusCode };
};

Error.propTypes = {
  statusCode: PropTypes.number.isRequired,
};

export default Error;
